"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateEndpointException = void 0;
var UpdateEndpointException;
(function (UpdateEndpointException) {
    UpdateEndpointException["BadRequestException"] = "BadRequestException";
    UpdateEndpointException["ForbiddenException"] = "ForbiddenException";
    UpdateEndpointException["InternalServerErrorException"] = "InternalServerErrorException";
    UpdateEndpointException["MethodNotAllowedException"] = "MethodNotAllowedException";
    UpdateEndpointException["NotFoundException"] = "NotFoundException";
    UpdateEndpointException["PayloadTooLargeException"] = "PayloadTooLargeException";
    UpdateEndpointException["TooManyRequestsException"] = "TooManyRequestsException";
})(UpdateEndpointException || (exports.UpdateEndpointException = UpdateEndpointException = {}));
